module.exports = __webpack_public_path__ + "img/toki_pona_logo.3e6c82c4.png";